import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Col, Modal, Row } from 'react-bootstrap'
import { Button, Loading, SwitchV2 } from 'src/components'

import {
  actions,
  getTermsConditions,
  onCreateConnection,
} from 'src/actions/cardProvider.actions'

import { loadingSelector } from 'src/selectors/loading.selector'
import { handlerError, handlerSuccess, hasErrors } from 'src/selectors/error.selector'
import { selectCardProviderTermsConditions } from 'src/selectors/cardProvider.selector'
import { showAlert } from 'src/actions/alert.actions'
import { DangerousSetInnerHTML } from 'src/components/DangerousInnerHtml/DangerousSetInnerHTML'

interface ICardPagaloTermsConditionsProps {
  show: boolean
  request: IPagaloRequest
  onHide: (success?: boolean) => void
}

interface IFlags {
  get: boolean
  create: boolean
}

export const CardPagaloTermsConditions = ({
  show,
  request,
  onHide,
}: ICardPagaloTermsConditionsProps) => {
  const dispatch = useDispatch()

  const loading = useSelector(state =>
    loadingSelector([actions.GET_CARD_TERMS_CONDITIONS])(state),
  )
  const error = useSelector(state =>
    hasErrors([actions.GET_CARD_TERMS_CONDITIONS])(state),
  )

  const termsConditions: string = useSelector(selectCardProviderTermsConditions)

  const loadingCreate = useSelector(state =>
    loadingSelector([actions.CREATE_CARD_CONNECTION])(state),
  )
  const errorCreate = useSelector(state =>
    hasErrors([actions.CREATE_CARD_CONNECTION])(state),
  )

  const [flags, setFlags] = useState<IFlags>({
    get: false,
    create: false,
  })
  const [accepted, setAccept] = useState<boolean>(false)

  useEffect(() => {
    if (!show) return
    dispatch(getTermsConditions(1))
    setAccept(false)
  }, [show])

  useEffect(() => {
    if (loading) setFlags({ ...flags, get: true })
    else if (flags.get) {
      setFlags({ ...flags, get: false })

      let messageError: string

      if (error)
        messageError =
          error.message ?? 'Error al obtener los términos y condiciones del proveedor'
      else if (termsConditions && termsConditions === 'NOT FOUND')
        messageError = 'No se pudo obtener los términos y condiciones del proveedor'

      if (messageError)
        dispatch(
          showAlert({
            ...handlerError(messageError),
            onConfirm: () => onHide(),
          }),
        )
    }
  }, [loading])

  useEffect(() => {
    if (loadingCreate) setFlags({ ...flags, create: true })
    else if (flags.create) {
      setFlags({ ...flags, create: true })
      const alert = errorCreate
        ? handlerError(errorCreate.message)
        : {
            ...handlerSuccess(),
            onConfirm: () => onHide(true),
          }
      dispatch(showAlert(alert))
    }
  }, [loadingCreate])

  const onProcess = () => {
    const connection: ICardProviderConnection = {
      providerId: 1,
      request: JSON.stringify(request),
    }

    dispatch(onCreateConnection(connection))
  }

  return (
    <Modal show={show} size={'lg'} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Términos y condiciones</Modal.Title>
      </Modal.Header>
      <Modal.Body className={'custom-modal-body'}>
        {loading ? (
          <Loading show />
        ) : (
          <Row>
            <Col xl={12}>
              <DangerousSetInnerHTML content={termsConditions} />
            </Col>
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer className={'container-buttons'}>
        <SwitchV2
          label={'Acepto los términos y condiciones'}
          onChange={setAccept}
          checked={accepted}
          info={''}
          disabled={loadingCreate}
        />
        <Button disabled={!accepted} onClick={onProcess} loading={loadingCreate}>
          Continuar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
